import React, { useEffect, useState } from 'react';
import CabecalhoProjeto from '../components/CabecalhoProjeto';
import axios from 'axios';
import { API_URL } from '../../api';

const AcoesPosProducaoResumo = ({ mostrar, onVoltarAoProjeto, anpSelecionada, dadosForm }) => {
  const [processoSelecionadoParaAcoes, setProcessoSelecionadoParaAcoes] = useState(null);
  const [modalAcoesAberto, setModalAcoesAberto] = useState(false);

  const handleAbrirAcoes = (processo) => {
    console.log('🚀 Abrindo modal de ações para:', processo);
    setProcessoSelecionadoParaAcoes(processo);
    setModalAcoesAberto(true);
  };

  const [cabecalho, setCabecalho] = useState(null);
  // Função segura para exibir arrays ou strings
const formatarArray = (valor) => {
  if (Array.isArray(valor)) return valor.join(', ');
  try {
    const parsed = JSON.parse(valor);
    if (Array.isArray(parsed)) return parsed.join(', ');
  } catch {}
  return typeof valor === 'string' ? valor : '—';
};

  const [acoes, setAcoes] = useState([]);

const atualizarStatusNoBackend = async (processo, novosDados) => {
let acaoAtual = acoes.find(a => a.processo === processo);

if (!acaoAtual) {
  // Cria uma nova estrutura se não existir
  acaoAtual = {
    processo,
    data: [new Date().toISOString()],
    sintomas: [''],
    causas: [''],
    solucoes: [''],
    status: [''],
    avaliacao: [''],
    responsavel: [''],
    prazo: [new Date().toISOString()]
  };

  setAcoes(prev => [...prev, acaoAtual]);
}


  const payload = {
    processo,
    anpId: anpSelecionada.id,
    dataOcorrencia: acaoAtual.data,
    sintomas: acaoAtual.sintomas,
    causas: acaoAtual.causas,
    solucoes: acaoAtual.solucoes,
    status: novosDados.status || acaoAtual.status,
    avaliacao: novosDados.avaliacao || acaoAtual.avaliacao,
    responsavel: acaoAtual.responsavel,
    prazo: acaoAtual.prazo
  };

  try {
    await axios.post(`${API_URL}/anp/salvar-acoes`, payload);

    const novas = acoes.map(acao => {
      if (acao.processo === processo) {
        return { ...acao, ...novosDados };
      }
      return acao;
    });

    setAcoes(novas);
    console.log('✅ Dados atualizados no backend.');
  } catch (error) {
    console.error('❌ Erro ao salvar:', error);
    alert('Erro ao atualizar os dados.');
  }
};







  useEffect(() => {
    if (!anpSelecionada?.id) return;

    const carregarDados = async () => {
      try {
        const [resAnps, resAcoes] = await Promise.all([
          axios.get(`${API_URL}/anp/listar`),
          axios.get(`${API_URL}/anp/acoes-por-anp/${anpSelecionada.id}`)
        ]);

        const anp = (resAnps.data || []).find(a => a.id?.toString() === anpSelecionada.id.toString());

        if (!anp) {
          console.warn('ANP não encontrada com o ID:', anpSelecionada.id);
          return;
        }

        setCabecalho({
          nomeCliente: anp.nomeCliente || '',
          codigoIM: anp.codigoIM || '',
          codigoCV: anp.codigoCV || '',
          op: anp.op || '',
          data: anp.data || '',
          dataEntrega: anp.cabecalho?.dataEntrega || '',
          dataAberturaOP: anp.cabecalho?.dataAberturaOP || '',
          descricaoProduto: anp.descricaoProduto || anp.cabecalho?.descricaoProduto || ''
        });

       const parseArray = (val) => {
  try {
    const parsed = JSON.parse(val || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const lista = (resAcoes.data || []).map(acao => ({
  processo: acao.processo,
  data: parseArray(acao.dataOcorrencia),
  sintomas: parseArray(acao.sintomas),
  causas: parseArray(acao.causas),
  solucoes: parseArray(acao.solucoes),
  status: parseArray(acao.status),
  avaliacao: parseArray(acao.avaliacao),
  responsavel: parseArray(acao.responsavel),
  prazo: parseArray(acao.prazo)
}));



        setAcoes(lista);
      } catch (err) {
        console.error('Erro ao carregar resumo da ANP:', err);
      }
    };

    carregarDados();
  }, [anpSelecionada]);

  return (
    <div style={{ maxWidth: 1000, margin: 'auto', padding: 24 }}>
      <div style={{ textAlign: 'left', marginBottom: 20 }}>
        <button
          onClick={() => {
            if (typeof onVoltarAoProjeto === 'function') {
              console.log('🔙 Voltando para ANP preenchida');
              onVoltarAoProjeto();
            }
          }}
          style={{
            padding: '10px 22px',
            fontSize: 16,
            background: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            marginBottom: 20
          }}
        >
          ← Voltar ao Projeto
        </button>
      </div>

      {cabecalho && (
        <div style={{ marginBottom: 32 }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h1 style={{ fontSize: 24, fontWeight: 700 }}>
              Resumo das Ações Pós Produção
            </h1>
          </div>
          <fieldset style={{ padding: 16, border: '2px solid #c00', background: '#fff8f8' }}>
            <legend><b>Produção do Produto</b></legend>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
              <p><b>OP:</b> {cabecalho.op}</p>
              <p><b>Cliente:</b> {cabecalho.nomeCliente || '—'}</p>
              <p><b>Data Abertura OP:</b> {cabecalho.dataAberturaOP ? new Date(cabecalho.dataAberturaOP).toLocaleDateString('pt-BR') : '—'}</p>
              <p><b>Código IM:</b> {cabecalho.codigoIM}</p>
              <p><b>Código CV:</b> {cabecalho.codigoCV}</p>
              <p><b>Data Entrega:</b> {cabecalho.dataEntrega ? new Date(cabecalho.dataEntrega).toLocaleDateString('pt-BR') : '—'}</p>
            </div>
            <div style={{ marginTop: 12 }}>
              <b>Descrição do Produto:</b>
              <p>{cabecalho.descricaoProduto || '—'}</p>
            </div>
          </fieldset>
        </div>
      )}

      {acoes.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#888', fontSize: 16 }}>
          Nenhuma ação preenchida encontrada para esta ANP.
        </div>
      ) : (
        acoes.map((acao, i) => (
          <div
            key={i}
            style={{
              border: '2px solid #ddd',
              borderRadius: 12,
              padding: 20,
              marginBottom: 28,
              background: '#fff',
              boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
            }}
          >



           
  <h2 style={{ fontSize: 20, color: '#333', marginBottom: 16 }}>🔧 {acao.processo}</h2>
  <p style={{ margin: '4px 0 12px', color: '#555' }}>
  Total de ocorrências registradas: <b>{acao.sintomas?.length || 0}</b>
</p>


{Array.isArray(acao.sintomas) && acao.sintomas.length > 0 ? (
  acao.sintomas.map((_, idx) => (
    <div
      key={idx}
      style={{
        borderTop: '1px solid #ddd',
        paddingTop: 16,
        marginTop: 16
      }}
    >
      <h4 style={{ marginBottom: 8 }}>🧾 Situação {idx + 1}</h4>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <p><b>Data Ocorrência:</b> {acao.data?.[idx] ? new Date(acao.data[idx]).toLocaleDateString('pt-BR') : '—'}</p>
        <p><b>Prazo:</b> {acao.prazo?.[idx] ? new Date(acao.prazo[idx]).toLocaleDateString('pt-BR') : '—'}</p>
        <p><b>Responsável:</b> {acao.responsavel?.[idx] || '—'}</p>
        <p><b>Status:</b> {acao.status?.[idx] || '—'}</p>

      </div>

      <p><b>🩺 Situação:</b> {acao.sintomas?.[idx] || '—'}</p>
      <p><b>🧪 Causa:</b> {acao.causas?.[idx] || '—'}</p>
      <p><b>🛠️ Solução:</b> {acao.solucoes?.[idx] || '—'}</p>
      <p><b>📊 As Soluções propostas foram eficazes?:</b></p>

{acao.avaliacao?.[idx] ? (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <p style={{ margin: 0 }}>{acao.avaliacao[idx]}</p>
    <button
      onClick={() => {
        const novaAvaliacao = [...acao.avaliacao];
        novaAvaliacao[idx] = '';
        atualizarStatusNoBackend(acao.processo, { avaliacao: novaAvaliacao });
      }}
      style={{
        marginLeft: 16,
        background: '#f5f5f5',
        color: '#333',
        padding: '4px 10px',
        border: '1px solid #ccc',
        borderRadius: 6,
        fontSize: 12,
        cursor: 'pointer'
      }}
    >
      🔁 Refazer Avaliação
    </button>
  </div>
) : (
  <div style={{ marginTop: 15, display: 'flex', gap: 12 }}>
  <button
    onClick={() => {
      const novaAvaliacao = Array.isArray(acao.avaliacao) ? [...acao.avaliacao] : [];
      novaAvaliacao[idx] = '🎉 Parabéns pelo empenho de todos os Envolvidos!';
      atualizarStatusNoBackend(acao.processo, { avaliacao: novaAvaliacao });
    }}
    style={{
      background: '#2e7d32',
      color: '#fff',
      padding: '6px 12px',
      border: 'none',
      borderRadius: 6,
      fontWeight: 'bold',
      cursor: 'pointer'
    }}
  >
    ✅ SIM
  </button>

  <button
    onClick={() => {
      const novaAvaliacao = Array.isArray(acao.avaliacao) ? [...acao.avaliacao] : [];
      novaAvaliacao[idx] = '💡 Ok, vamos continuar tentando encontrar uma solução eficaz para este problema.';
      atualizarStatusNoBackend(acao.processo, { avaliacao: novaAvaliacao });
    }}
    style={{
      background: '#c62828',
      color: '#fff',
      padding: '6px 12px',
      border: 'none',
      borderRadius: 6,
      fontWeight: 'bold',
      cursor: 'pointer'
    }}
  >
    ❌ NÃO
  </button>
</div>

)}




<div style={{ display: 'flex', gap: 12, marginTop: 50 }}>
<button
  onClick={() => {
    const novaStatus = Array.isArray(acao.status) ? [...acao.status] : [];
    novaStatus[idx] = 'Concluído';
    atualizarStatusNoBackend(acao.processo, { status: novaStatus });
  }}

  style={{
    background: '#2e7d32',
    color: '#fff',
    padding: '6px 12px',
    border: 'none',
    borderRadius: 6,
    fontWeight: 'bold',
    cursor: 'pointer'
  }}
>
  ✅ CONCLUÍDO
</button>


<button
  onClick={() => {
    const novaStatus = Array.isArray(acao.status) ? [...acao.status] : [];
    novaStatus[idx] = 'Parcial';
    atualizarStatusNoBackend(acao.processo, { status: novaStatus });
  }}
  style={{
    background: '#ef6c00',
    color: '#fff',
    padding: '6px 12px',
    border: 'none',
    borderRadius: 6,
    fontWeight: 'bold',
    cursor: 'pointer'
  }}
>
  🟠 PARCIALMENTE CONCLUÍDO
</button>


<button
  onClick={() => {
    const novaStatus = Array.isArray(acao.status) ? [...acao.status] : [];
    novaStatus[idx] = 'Estourado';
    atualizarStatusNoBackend(acao.processo, { status: novaStatus });
  }}

  style={{
    background: '#c62828',
    color: '#fff',
    padding: '6px 12px',
    border: 'none',
    borderRadius: 6,
    fontWeight: 'bold',
    cursor: 'pointer'
  }}
>
  ❌ FORA DO PRAZO 
</button>

</div>


    </div>
  ))
) : (
  <div>
    <p><i>Nenhuma ocorrência registrada.</i></p>
  </div>
)}



          </div>
        ))
      )}

      {modalAcoesAberto && processoSelecionadoParaAcoes && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 8,
            padding: 24,
            maxWidth: 600,
            width: '90%',
            boxShadow: '0 0 10px rgba(0,0,0,0.3)'
          }}>
            <h2 style={{ marginTop: 0 }}>✏️ Ações do Processo: {processoSelecionadoParaAcoes}</h2>
            <div style={{ marginTop: 24, textAlign: 'right' }}>
              <button
                onClick={() => setModalAcoesAberto(false)}
                style={{
                  padding: '10px 18px',
                  background: '#1976d2',
                  color: 'white',
                  border: 'none',
                  borderRadius: 6,
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AcoesPosProducaoResumo;
